module.exports = __webpack_public_path__ + "img/about-icon3.5e8c211d.png";